import { faRectangleAd } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

// import { UpdateAdForm } from '~/components/forms/AdForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';
import { useAdQuery } from '~/lib/api/modules/Ads/hooks/useAdQuery';
import { QuerySkeleton } from '../atoms/QuerySkeleton';
import { UpdateAdForm } from '../forms/AdForm';
import { Heading } from '../molecules/Heading';
import { AppBreadcrumbs } from '../organisms/Breadcrumbs';

export type IAppUpdateAdPageProps = {
  appId: string;
  adId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppUpdateAdPage: React.FC<IAppUpdateAdPageProps> = (props) => {
  const { appId, adId, nextUrl, cancelUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const adQuery = useAdQuery({
    appId,
    adId,
  });

  const parentUrl = `/apps/${appId}/ads`;

  return (
    <>
      <Helmet>
        <title>{t('AppUpdateAdPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faRectangleAd} />
          {t('AppAdsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={
          <QuerySkeleton query={adQuery} length={{ min: 8, max: 16 }}>
            {t('AppUpdateAdPage.title')}
          </QuerySkeleton>
        }
        previousUrl={parentUrl}
      />

      <UpdateAdForm
        appId={appId}
        adId={adId}
        onSuccess={() => navigate(nextUrl ?? parentUrl)}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
